import { SetPasswordScreen } from "@/features/auth/screens/SetPasswordScreen";
import { hasConfirmedEmail } from "@/features/auth/utils/hasConfirmedEmail";
import { supabaseClient } from "@/lib/supabase";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/set-password")({
    component: SetPasswordScreen,
    beforeLoad: async () => {
        const {
            data: { user },
        } = await supabaseClient.auth.getUser();
        // A password on an account without a verified email can't be used to log in or be reset.
        if (user && !hasConfirmedEmail(user)) {
            const pendingEmail = user.new_email ?? (user.user_metadata?.email as string | undefined);
            if (pendingEmail) {
                throw redirect({ to: "/verify-email", search: { email: pendingEmail, first_name: "", last_name: "" } });
            }
        }
    },
});
